import { useState } from "react";
import { Form, Button, InputGroup, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { LoginFormType } from "../types/login";
import { LoginSchema } from "../validation/login.schema";
import { useLogin } from "../hooks/useAuth";
import { SiteLogo } from "src/assets";
import { LoginBg } from "src/assets";

export default function AnalyticsLogin() {
  const [showPassword, setShowPassword] = useState(false);

  const { mutate: login, isPending } = useLogin();

  const { control, handleSubmit } = useForm<LoginFormType>({
    mode: "onBlur",
    resolver: zodResolver(LoginSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });

  return (
    <>
      <div className="login-page d-flex flex-fill">
          <div className="col-form">
              <div className="logo mb-3">
                  <img src={SiteLogo} alt="Site logo" />
              </div>
              <div>
                  <h3 className="mb-2 text-purple">Welcome back!</h3>
                  <p className="mb-2">Sign in to access the foresight platform</p>
              </div>

              <Form onSubmit={handleSubmit((values) => login(values))}>
                  <Controller
                      name="email"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                          <Form.Group className="mb-5" controlId="formEmail">
                              <Form.Label className="float-start mb-2">
                                  Email address *
                              </Form.Label>
                              <div className="input-group">
                                  <span className="input-group-text"><i className="bi bi-envelope"></i></span>
                                  <Form.Control
                                      {...field}
                                      type="email"
                                      // placeholder="Email"
                                      isInvalid={!!(error && error.message)}
                                  />
                              </div>
                              {error && error.message && (
                                  <div className="text-danger small mt-1">
                                      {error.message}
                                  </div>
                              )}
                          </Form.Group>
                      )}
                  />

                  <Controller
                      name="password"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                          <Form.Group className="mb-4" controlId="formPassword">
                              <Form.Label className="float-start mb-2">
                                  Password *
                              </Form.Label>
                              <div className="input-group">
                                  <InputGroup>
                                      <span className="input-group-text"><i className="bi bi-lock"></i></span>
                                      <Form.Control
                                          type={showPassword ? "text" : "password"}
                                          {...field}
                                          isInvalid={!!(error && error.message)}
                                          minLength={8}
                                          //   maxLength={50}
                                      />
                                      <InputGroup.Text
                                          onClick={() => setShowPassword(!showPassword)}
                                          style={{
                                              cursor: "pointer",
                                              backgroundColor: "white",
                                          }}
                                      >
                                          {showPassword ? (
                                              <i className="bi bi-eye"></i>
                                          ) : (
                                              <i className="bi bi-eye-slash"></i>
                                          )}
                                      </InputGroup.Text>
                                  </InputGroup>
                              </div>
                              {error && error.message && (
                                  <div className="text-danger small mt-1">
                                      {error.message}
                                  </div>
                              )}
                          </Form.Group>
                      )}
                  />

                  <div className="my-5">
                      <Button
                          className="w-100"
                          variant="purple"
                          type="submit"
                          disabled={isPending}
                          style={{ minHeight:'45px'}}
                      >
                          {isPending && (
                              <Spinner
                                  className="me-1"
                                  animation="border"
                                  size="sm"
                                  role="status"
                              >
                                  <span className="visually-hidden">Loading...</span>
                              </Spinner>
                          )}
                          Sign in
                      </Button>
                  </div>
              </Form>
              <p className="small text-center text-primary m-0">
                  © 2026 Elusa Health All rights reserved
              </p>
          </div>
          <div className="col-bg">
              <div className="bg-text">
                  <h2 className="mb-2">
                      Smarter Insights.
                      <br/>
                      Better Patient Outcomes.
                  </h2>
                  <p className="mb-2">
                      Foresight transforms patient services data into actionable intelligence, empowering pharmaceutical
                      manufacturers to optimize patient access, enhance program performance, and improve patient outcomes.
                  </p>
              </div>
          </div>
      </div>
      {/*<Container*/}
      {/*  fluid*/}
      {/*  className="vh-100 d-flex align-items-center justify-content-center bg-light"*/}
      {/*>*/}
      {/*  <Row className="w-100 justify-content-center">*/}
      {/*    <Col xs={12} sm={10} md={8} lg={6} xl={4}>*/}
      {/*      <Card className="shadow-lg border-0">*/}
      {/*        <Card.Body className="p-5">*/}
      {/*          <div className="text-center mb-4">*/}
      {/*            <h2 className="fw-bold text-primary">Analytics Platform</h2>*/}
      {/*            <p className="text-muted">Sign in to your account</p>*/}
      {/*          </div>*/}

      {/*          <Form onSubmit={handleSubmit((values) => login(values))}>*/}
      {/*            <Controller*/}
      {/*              name="email"*/}
      {/*              control={control}*/}
      {/*              render={({ field, fieldState: { error } }) => (*/}
      {/*                <Form.Group className="mb-3" controlId="formEmail">*/}
      {/*                  <Form.Label className="float-start">Email *</Form.Label>*/}
      {/*                  <Form.Control*/}
      {/*                    {...field}*/}
      {/*                    type="email"*/}
      {/*                    placeholder="Email"*/}
      {/*                    isInvalid={!!(error && error.message)}*/}
      {/*                  />*/}
      {/*                  {error && error.message && (*/}
      {/*                    <div className="text-danger small mt-1">*/}
      {/*                      {error.message}*/}
      {/*                    </div>*/}
      {/*                  )}*/}
      {/*                </Form.Group>*/}
      {/*              )}*/}
      {/*            />*/}

      {/*            <Controller*/}
      {/*              name="password"*/}
      {/*              control={control}*/}
      {/*              render={({ field, fieldState: { error } }) => (*/}
      {/*                <Form.Group className="mb-3" controlId="formPassword">*/}
      {/*                  <Form.Label className="float-start">*/}
      {/*                    Password **/}
      {/*                  </Form.Label>*/}
      {/*                  <InputGroup>*/}
      {/*                    <Form.Control*/}
      {/*                      type={showPassword ? "text" : "password"}*/}
      {/*                      placeholder="Password"*/}
      {/*                      {...field}*/}
      {/*                      isInvalid={!!(error && error.message)}*/}
      {/*                      minLength={8}*/}
      {/*                      maxLength={50}*/}
      {/*                    />*/}
      {/*                    <InputGroup.Text*/}
      {/*                      onClick={() => setShowPassword(!showPassword)}*/}
      {/*                      style={{*/}
      {/*                        cursor: "pointer",*/}
      {/*                        backgroundColor: "white",*/}
      {/*                      }}*/}
      {/*                    >*/}
      {/*                      {showPassword ? (*/}
      {/*                        <i className="bi bi-eye"></i>*/}
      {/*                      ) : (*/}
      {/*                        <i className="bi bi-eye-slash"></i>*/}
      {/*                      )}*/}
      {/*                    </InputGroup.Text>*/}
      {/*                  </InputGroup>*/}
      {/*                  {error && error.message && (*/}
      {/*                    <div className="text-danger small mt-1">*/}
      {/*                      {error.message}*/}
      {/*                    </div>*/}
      {/*                  )}*/}
      {/*                </Form.Group>*/}
      {/*              )}*/}
      {/*            />*/}

      {/*            <div className="d-grid">*/}
      {/*              <Button variant="primary" type="submit" disabled={isPending}>*/}
      {/*                {isPending && (*/}
      {/*                  <Spinner*/}
      {/*                    className="me-1"*/}
      {/*                    animation="border"*/}
      {/*                    size="sm"*/}
      {/*                    role="status"*/}
      {/*                  >*/}
      {/*                    <span className="visually-hidden">Loading...</span>*/}
      {/*                  </Spinner>*/}
      {/*                )}*/}
      {/*                Sign In*/}
      {/*              </Button>*/}
      {/*            </div>*/}
      {/*          </Form>*/}

      {/*          /!* <div className="text-center mt-3">*/}
      {/*            <a*/}
      {/*              href="/forgot-password"*/}
      {/*              className="text-decoration-none small"*/}
      {/*            >*/}
      {/*              Forgot password?*/}
      {/*            </a>*/}
      {/*          </div> *!/*/}
      {/*        </Card.Body>*/}
      {/*      </Card>*/}
      {/*    </Col>*/}
      {/*  </Row>*/}
      {/*</Container>*/}
    </>
  );
}
